import {
  SET_USER,
  SET_LOCALE,
} from './user_constants';

export const setUser = (payload) => ({
  type: SET_USER,
  payload,
});

export const setLocale = (payload) => ({
  type: SET_LOCALE,
  payload,
});
